/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */

import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Subject ,  Observable } from 'rxjs';

@Injectable()
export class IntegrationAuditSerivce {

  private auditLogUrl: string = environment.host + '/integrationLogs/filter';
  private auditReportUrl: string = environment.host + '/report/IntegrationAudit';
  private retryUrl: string = environment.host + '/integrationLogs/retry';

  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;

  constructor(private http: HttpClient) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  public getAllAuditLogs(payload: any, startRecord: any, recordsSize: any) {
    const filterURL = this.auditLogUrl + '?pageMaxId=' + startRecord + '&size=' + recordsSize;
    return this.http.post(filterURL, payload).pipe(
      map(response => response))
  }

  public getReportDetails() {
    const auditReportUrl = this.auditReportUrl;
    return this.http.get(auditReportUrl).toPromise();
  }

  public retryIntegrationLog(payload: any){
    return this.http.post(this.retryUrl.toString(), payload).toPromise();
  }

  public getIntegrationRequestPayloadFile(requestId: string) {
    const url = environment.host + '/integrationLogs/requestPayload/download?id=' + requestId;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json; charset=utf-8');
    return this.http.get(url, { headers: headers, responseType: 'blob' }).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/json; charset=utf-8' });
      })
    );
  }
}
